/*SYSTEM IMPORTS*/
    import React, { Fragment } from 'react'
    import c from 'classnames'
    import { Portal } from 'components/Portal'
    import MediaQuery from 'react-responsive'

    const PopupUi = ({ show = false, className = "", children = null, onRef, onClose }) => (
        <div className={c( "popup", { show: show }, className )} ref={onRef}>
            <div className="content">
                <div className="close" onClick={ onClose }>&times;</div>

                {children}
            </div>
        </div>
    )

    const Popup = ({ portralFrom = false, modal = false, ...props }) => {
        if (modal) {
            return (
                <Portal id="popup-modal-wrapper" out="modal-block-wrapper">
                    <PopupUi {...props} />
                </Portal>
            )
        }

        if (portralFrom === false) {
            return (
                <PopupUi {...props} />
            )
        }

        return (
            <Fragment>
                <MediaQuery query={`(min-width: ${parseInt(portralFrom) + 1}px)`}>
                    <PopupUi {...props} />
                </MediaQuery>

                <MediaQuery query={`(max-width: ${parseInt(portralFrom)}px)`}>
                    <Portal id="popup-modal-wrapper" out="modal-block-wrapper">
                        <PopupUi {...props} />
                    </Portal>
                </MediaQuery>
            </Fragment>
        )
    }

    const PopupTitle = props => (
        <div className="popup-title">
            {props.children}
        </div>
    )

    const PopupText = props => (
        <div className="popup-text" {...props}>
            {props.children}
        </div>
    )

    export {PopupTitle, PopupText}
    export default Popup
